import React, { useState } from 'react';
import { uniqueId } from 'lodash';

import Tooltip from 'components/Tooltip';
import Button from 'components/Button';

import { Container } from './styles';

export interface FlagProps {
  name: string;
  type: string;
  tooltip?: string;
  icon?: JSX.Element | null;
  icon2?: JSX.Element | null;
  handleAction?: (() => void) | ((e: React.MouseEvent) => void);
  handleAction2?: () => void;
  disabled?: boolean;
  disabledButton?: boolean;
}

export default function Flag({
  name,
  type,
  tooltip,
  icon,
  icon2,
  handleAction,
  handleAction2,
  disabled = false,
  disabledButton = false,
}: FlagProps) {
  const [id] = useState(uniqueId(new Date().getTime().toString()));

  return (
    <>
      <Container disabled={disabled} id={`idtooltip_${id}`} type={type}>
        <span>{name}</span>
        {!!icon && (
          <Button
            fill
            color="flag"
            round
            size="xsm"
            onClick={handleAction}
            disabled={disabled || disabledButton}
          >
            {icon}
          </Button>
        )}

        {!!icon2 && (
          <Button
            fill
            color="flag"
            round
            size="xsm"
            onClick={handleAction2}
            disabled={disabled || disabledButton}
          >
            {icon2}
          </Button>
        )}
      </Container>
      {!!tooltip && <Tooltip target={`idtooltip_${id}`}>{tooltip}</Tooltip>}
    </>
  );
}
